module.exports = __webpack_public_path__ + "img/blocco-loghi-porcreo.8b27d167.png";